import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    { icon: <MapPin size={24} className="text-teal-600" />, title: 'Visit Us', details: 'Kk Complex, At-Thana, Amgaon, Gondia, Maharashtra - 441902' },
    { icon: <Phone size={24} className="text-teal-600" />, title: 'Call Us', details: '+91 7972285589' },
    { icon: <Mail size={24} className="text-teal-600" />, title: 'Email Us', details: 'kkpharma44@gmail.com',  },
    { icon: <Clock size={24} className="text-teal-600" />, title: 'Business Hours', details: 'Monday - Saturday: 9:00 AM - 5:00 PM', sub: 'Sunday: Closed' },
  ];

  return (
    <div className="py-16 bg-gray-50">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Contact Us</h1>
          <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full"></div>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4">
            Have questions or need assistance? Reach out to us — we're here to help with your pharmaceutical needs.
          </p>
        </div>

        {/* Contact Information Cards - Full Width */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Get in Touch</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg hover:shadow-md transition-shadow duration-300">
                  <div className="flex-shrink-0 mt-1">{info.icon}</div>
                  <div>
                    <h3 className="font-semibold text-gray-800">{info.title}</h3>
                    <p className="text-gray-600">{info.details}</p>
                    {info.sub && <p className="text-gray-500 text-sm">{info.sub}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Map */}
          <div className="mt-6 bg-white rounded-xl shadow-lg overflow-hidden">
            <iframe
              title="KK Pharmaceuticals Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29760.418044133278!2d80.3286!3d21.2599!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2a2b0c5a4c3d1f%3A0x4c3a2b1a0f5e6d7c!2sGondia%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;